var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-box"},[_c('div',{attrs:{"id":"fb-root"}}),_vm._v(" "),_c('div',{ref:"video",staticClass:"video-wrap",domProps:{"innerHTML":_vm._s(_vm.embedVideo)}})])}
var staticRenderFns = []

export { render, staticRenderFns }